import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";
import styles from "./Typography.module.scss";

export default function Quote(props) {
  const { text, author, authorClassName, textClassName } = props;
  const quoteClasses = classNames(styles.defaultFontStyle, styles.quote);
  const quoteTextClasses = classNames(styles.quoteText, textClassName);
  const quoteAuthorClasses = classNames(styles.quoteAuthor, authorClassName);
  return (
    <blockquote className={quoteClasses}>
      <p className={quoteTextClasses}>{text}</p>
      <small className={quoteAuthorClasses}>{author}</small>
    </blockquote>
  );
}

Quote.propTypes = {
  text: PropTypes.node,
  author: PropTypes.node,
  textClassName: PropTypes.string,
  authorClassName: PropTypes.string
};
